import { useIntl } from 'react-intl';
import { ButtonUI, Prompt } from 'sonata-react-components';

import './confirmPrompt.scss';

type Props = {
  selectedIdsSize: number;
  venuesNotFoundCount: number;
  venuesAddedCount: number;
  onClose: () => void;
  onConfirm: () => void;
};

export function ConfirmPrompt({ selectedIdsSize, venuesNotFoundCount, venuesAddedCount, onClose, onConfirm }: Props) {
  const { formatMessage } = useIntl();

  return (
    <Prompt className="confirmPrompt" closePrompt={onClose} width="770px">
      <Prompt.Title>
        {formatMessage({
          defaultMessage: 'Confirm your POIs',
          id: 'poiImporter.prompt.title'
        })}
      </Prompt.Title>
      <Prompt.Description>
        {formatMessage(
          {
            defaultMessage: `Keep in mind you are going to add only ${selectedIdsSize} POIs from a file of ${venuesAddedCount} POIs`,
            id: 'poiImporter.prompt.description'
          },
          { pois: selectedIdsSize, total: venuesAddedCount }
        )}
      </Prompt.Description>
      <div className="confirmPrompt__container">
        <div className="confirmPrompt__promptSelectedPOIs">
          <p>
            {formatMessage({
              defaultMessage: 'Selected POIs:',
              id: 'poiImporter.prompt.selectedPOIs'
            })}
          </p>
          <span>
            {formatMessage(
              {
                defaultMessage: `${selectedIdsSize} POIs`,
                id: 'poiImporter.prompt.selectedPOIsTotal'
              },
              { pois: selectedIdsSize }
            )}
          </span>
        </div>
        {venuesAddedCount > 0 && (
          <div className="confirmPrompt__promptNotFoundPOIs">
            <p>
              {formatMessage({
                defaultMessage: 'Not Found: ',
                id: 'poiImporter.prompt.notFoundPOIs'
              })}
            </p>
            <span>
              {formatMessage(
                {
                  defaultMessage: `${venuesNotFoundCount} POIs`,
                  id: 'poiImporter.prompt.notFoundPOIsTotal'
                },
                { pois: venuesNotFoundCount }
              )}
            </span>
          </div>
        )}
      </div>
      <Prompt.Buttons position="centered">
        <ButtonUI
          onClick={onClose}
          shape="squareRounded"
          text={formatMessage({ defaultMessage: 'Cancel', id: 'common.cancel' })}
          type="secondary"
        />
        <ButtonUI
          onClick={onConfirm}
          shape="squareRounded"
          text={formatMessage({
            defaultMessage: 'Confirm & Add',
            id: 'poiImporter.prompt.confirmAdd'
          })}
          type="primary"
        />
      </Prompt.Buttons>
    </Prompt>
  );
}
